import type { RasterLayerSource } from '@/hooks/useDatasets';
import { releaseTilesPath } from './releaseTiles';
import type { LayerConfig } from './types';
import { LayerType } from './types';
import { TileLayer } from '@deck.gl/geo-layers';
import type { Color } from '@deck.gl/core';
import { BitmapLayer } from '@deck.gl/layers';
import { getGeoBoundingBox } from '@/views/map/utils';

export const getTreeTypeLayer = (
  source: RasterLayerSource,
  config: LayerConfig,
  isInspectMode: boolean,
  minZoom = 16,
  maxZoom = 24
) => getRasterLayer(source, config, isInspectMode, minZoom, maxZoom);

export const DECIDUOUS_COLOR: Color = [250, 65, 253, 150];
export const DECIDUOUS_COLOR_SAFARI: Color = [249, 64, 253, 150]; //Temporary addition since safari renders rgb slightly different. Needs to be fixed in a way that we can get the 1 & 2 from rasters instead of pixelColors.
export const EVERGREEN_COLOR: Color = [6, 223, 27, 150];
export const EVERGREEN_COLOR_SAFARI: Color = [6, 222, 27, 150]; //Temporary addition since safari renders rgb slightly different. Needs to be fixed in a way that we can get the 1 & 2 from rasters instead of pixelColors.

const getRasterLayer = (
  source: RasterLayerSource,
  config: LayerConfig,
  isInspectMode: boolean,
  minZoom: number,
  maxZoom: number
) => {
  const cmap = {
    '1': DECIDUOUS_COLOR,
    '2': EVERGREEN_COLOR,
  };
  const cmap_param = encodeURIComponent(JSON.stringify(cmap));

  return new TileLayer({
    id: LayerType[LayerType.tree_type],
    data: `${releaseTilesPath(source, 'png')}?pixel_selection=first&return_mask=true&bidx=1&resampling=nearest&colormap=${cmap_param}&tilesize=512`,
    loadOptions: {
      fetch: {
        credentials: 'include',
      },
    },
    pickable: true,
    opacity: isInspectMode && !config.visible ? 0 : 1,
    minZoom,
    maxZoom,
    visible: isInspectMode || config.visible,
    renderSubLayers: (props) => {
      if (props.data === null) {
        return null;
      }

      const boundingBox = getGeoBoundingBox(props);
      if (!boundingBox) {
        return null;
      }
      const { west, south, east, north } = boundingBox;

      return new BitmapLayer({
        id: props.id,
        image: props.data,
        bounds: [west, south, east, north],
        pickable: props.pickable,
        opacity: props.opacity,
        visible: props.visible,
        highlightColor: props.highlightColor,
      });
    },
  });
};
